export default function () {

	document.addEventListener('DOMContentLoaded', function () {
		let openFilterButton = document.querySelector('.open-filter');
		let searchFormCont = document.getElementById('search-form-cont');

		if (searchFormCont && openFilterButton) {
			openFilterButton.addEventListener('click', function() {
				if (openFilterButton.classList.contains('opened')) {
					//Remove 'opened' class and hide search form
					openFilterButton.classList.remove('opened');
					searchFormCont.classList.remove('show');
					searchFormCont.classList.add('collapse');
				} else {
					//Add 'opened' class and show search form
					openFilterButton.classList.add('opened');
					searchFormCont.classList.remove('collapse');
					searchFormCont.classList.add('show');
				}
			});
		}
	});
}
